import React from 'react'
import { Button } from '@lmc/ui-kit'
import Glyph from '../../../../../../LEGACY/Glyph'
import styles from '../../CarePlanReiviewForm.styles'
import { useTranslation } from 'react-i18next'

interface ICarePlanReviewFooter {
  handleSubmit: () => void
  handleCancel: () => void
  isSubmitting: boolean
}

export const CarePlanReviewFooter = ({
  handleSubmit,
  handleCancel,
  isSubmitting,
}: ICarePlanReviewFooter): React.ReactElement => {
  const { t } = useTranslation()
  return (
    <div
      className="lmc-fixed-footer"
      style={{
        ...styles.footer,
      }}
    >
      <Button
        data-testid="care-plan-edit-cancel"
        dataTestId='care-plan-cancel'
        onClick={handleCancel}
        style={styles.cancelButton}
        variant="default"
      >
        {t('general.buttons.cancel')}
      </Button>
      <Button
        data-testid="care-plan-edit-save"
        dataTestId='care-plan-save'
        isLoading={isSubmitting}
        onClick={handleSubmit}
        variant="primary"
        icon={
          <Glyph
            name="check"
            aphroditeStyles={undefined}
            className={undefined}
            color={undefined}
            component={undefined}
            size={undefined}
            style={undefined}
          />
        }
      >
        {t('general.buttons.save')}
      </Button>
    </div>
  )
}

export default CarePlanReviewFooter
